<template>
  <a-row class="section" justify="space-between">
    <section-strategy-details :data-source="props.dataSource" class="section__details" />
    <div class="section__preview">
      <whatsapp-template-phone
        v-if="templateWhatsapp"
        :content="templateWhatsapp.template"
        :templateType="templateWhatsapp.template_type"
        :media-link="templateWhatsapp.template_media"
      />
    </div>
  </a-row>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import WhatsappTemplatePhone from "@/app/shared/components/organisms/WhatsappTemplatePhone.vue";
import SectionStrategyDetails from "@/app/strategies/components/sections/SectionStrategyDetails.vue";
import { DataSourceStrategy } from "@/@types/strategies/modalStrategy";

const props = defineProps<{
  dataSource: DataSourceStrategy;
}>();

const templateWhatsapp = computed(() => {
  return props.dataSource.template_whatsapp;
});
</script>

<style lang="sass">
.section
  &__details
    margin-right: 40px
    width: 180px
  &__preview
    width: 224px
</style>
